import { useSelector } from 'react-redux';
import { X, Folder } from 'lucide-react';

const AddToProjectModal = ({setIsProjectModalOpen, addItemToProject}) => {
  const projects = useSelector(state => state.projectList.projects);
  const tasks = useSelector(state => state.taskList.tasks);
  
  const projectTasks = (project) => tasks?.filter(task => task.metaData.projectId === project.id && !task.archived)
  const projectCompletedTasks = (project) => tasks?.filter(task => task.metaData.projectId === project.id && task.completed && !task.archived)
  const projectIsCompleted = (project) => (projectTasks(project).length > 0) && (projectCompletedTasks(project).length / projectTasks(project).length === 1);

  const getOpenProjects = () => {
    return projects.filter(project => (project.step === 'in_progress' && !project.archived && !projectIsCompleted(project)));
  }

  const handleSetIsModalOpenClick = (value) => {
    setIsProjectModalOpen(value)
  }

  const handleAddItemToProject = (projectId, projectTitle) => {
    addItemToProject(projectId, projectTitle);
    handleSetIsModalOpenClick(false);
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50">
      <div className="relative bg-white rounded-lg p-4 w-[500px]">
        <button onClick={() => handleSetIsModalOpenClick(false)} 
          className="text-gray-500 bg-transparent hover:bg-gray-100 rounded-sm p-1 absolute top-2 right-2"
        >
          <X size={24} />
        </button>

        <h2 className="text-xl font-bold mb-4">Select an Open Project</h2>

        <div className="max-h-[400px] overflow-y-auto">
          {getOpenProjects().reverse().map(project => (
            <button
              key={project.id}
              onClick={() => handleAddItemToProject(project.id, project.title)}
              className="flex m-0 items-center bg-gray-50 gap-2 border border-gray-200 border-solid rounded-md p-2 w-full text-left text-sm text-gray-600 hover:bg-gray-100 mb-2"
            >
              <Folder size={14} /> {project.title}
            </button>
          ))}
        </div>
      </div>
    </div>
  )
}

export default AddToProjectModal;